import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconUnstableExpand';
/** Renders an SVG icon. */
const SvgUnstableExpand = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" data-icon="true" {...props}>
      <path
        fill="currentColor"
        d="M19.5 20.25V3.75a.75.75 0 0 1 1.5 0v16.5a.75.75 0 0 1-1.5 0M11.47 6.22a.75.75 0 0 1 1.06 0l5.25 5.25a.75.75 0 0 1 0 1.06l-5.25 5.25a.75.75 0 1 1-1.06-1.06l3.97-3.97H5.25a.75.75 0 0 1 0-1.5h10.19l-3.97-3.97a.75.75 0 0 1 0-1.06"
      />
    </svg>
  );
};
SvgUnstableExpand.displayName = displayName;
export default SvgUnstableExpand;
